(ns frontend.ui.component.lp-portal.report.body.sparkmind.fund.controller
  (:require
   [frontend.ui.component.lp-portal.report.component.multi-chart.controller :as multi-controller]
   [frontend.ui.component.lp-portal.report.component.overview-figures.controller :as ov-ctl]
   [frontend.ui.component.lp-portal.report.component.waterfall-chart.controller :as waterfall-chart-ctl]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))


(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name             (:fund-name report-data)
   :reference-date        (get-in report-data [:reference-date])
   :reporting-period      (:reporting-period report-data)
   :overview-figures      (report-ctl/with-footnote
                           (update props :dynamic-path concat [:overview])
                           :overview-figures-footnotes
                           (ov-ctl/figures (get-in report-data [:overview-figures])))
   :fund-overview         {:case-overview   (report-ctl/rich-content
                                             props
                                             :case-overview-text)
                           :executive-summary-figures (report-ctl/with-footnote
                                                       props
                                                       :executive-summary-figures-footnotes
                                                       (:executive-summary report-data))
                           :fund-overview-1 (report-ctl/with-footnote
                                             props
                                             :fund-overview-footnotes
                                             (:fund-overview-1 report-data))
                           :fund-overview-2 (report-ctl/with-footnote
                                             props
                                             :fund-overview-footnotes
                                             (:fund-overview-2 report-data))}
   :fund-status           {:fund-value-bridge       (report-ctl/with-footnote
                                                     props
                                                     :fund-value-bridge-footnotes
                                                     (waterfall-chart-ctl/chart-config
                                                      (:fund-value-bridge report-data)
                                                      report-data))
                           :value-progression       (report-ctl/with-footnote
                                                     props
                                                     :value-progression-footnotes
                                                     (multi-controller/multi-chart-ctl
                                                      (:value-progression report-data)
                                                      report-data))
                           :net-asset-value         (report-ctl/with-footnote
                                                     props
                                                     :net-asset-value-footnotes
                                                     (:net-asset-value report-data))
                           :key-metrics             (report-ctl/with-footnote
                                                     props
                                                     :key-metrics-footnotes
                                                     (:key-metrics report-data))
                           :management-fees         (report-ctl/with-footnote
                                                     props
                                                     :management-fees-footnotes
                                                     (:management-fees report-data))
                           :transaction-and-other-fees (report-ctl/with-footnote
                                                        props
                                                        :transaction-and-other-fees-footnotes
                                                        (:transaction-and-other-fees report-data))
                           :carried-interest        (report-ctl/with-footnote
                                                     props
                                                     :carried-interest-footnotes
                                                     (:carried-interest report-data))
                           :fund-operating-expenses (report-ctl/with-footnote
                                                     props
                                                     :fund-operating-expenses-footnotes
                                                     (:fund-operating-expenses report-data))}
   :portfolio-information {:portfolio-summary    (report-ctl/with-footnote
                                                  props
                                                  :portfolio-summary-footnotes
                                                  (:portfolio-summary report-data))
                           :change-in-fair-value (report-ctl/with-footnote
                                                  props
                                                  :change-in-fair-value-footnotes
                                                  (:change-in-fair-value report-data))}
   :investor-information  {:capital-account-year-to-date    (report-ctl/with-footnote
                                                             props
                                                             :capital-account-year-to-date-footnotes
                                                             (:capital-account-year-to-date report-data))
                           :capital-account-since-inception (report-ctl/with-footnote
                                                             props
                                                             :capital-account-since-inception-footnotes
                                                             (:capital-account-since-inception report-data))}})
